import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useUpdateRoleMutation } from '~/features/user/model/api/users-api';
import { IModalRoleProps } from '~/shared/types/types';

export const ModalRole: React.FC<IModalRoleProps> = ({ open, handleClose, user, onUpdated }) => {
  const [role, setRole] = useState(user.role);

  useEffect(() => {
    if (user.role) {
      setRole(user.role);
    }
  }, [user.role]);

  const handleChange = (event: SelectChangeEvent) => {
    setRole(event.target.value as string);
  };
  const user_id = user.id;

  const [updateRole, { isLoading }] = useUpdateRoleMutation();

  const roleSubmit = useCallback(async () => {
    try {
      await updateRole({ user_id, role }).unwrap();
      handleClose();
      setRole('');
      onUpdated?.();
    } catch {}
  }, [handleClose, role, updateRole, user_id, onUpdated]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description">
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '24px',
          boxShadow: 24,
          pt: 2,
          px: 4,
          pb: 3,
          width: 400
        }}>
          <h3 id="child-modal-title">Выберите роль для "{user.name}"</h3>


          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{role}</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={role}
              label="Роль"
              disabled={isLoading}
              onChange={handleChange}>
              <MenuItem value={'admin'}>Admin</MenuItem>
              <MenuItem value={'buyer'}>Buyer</MenuItem>
              <MenuItem value={'farmer'}>Farmer</MenuItem>
            </Select>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '12px',
                pt: '12px',
                alignContent: 'end',
              }}>
              <Button variant="outlined" sx={{ flex: 1 }} onClick={handleClose} disabled={isLoading}>
                Отменить
              </Button>
              <Button
                disabled={user.role === role || isLoading}
                color="primary"
                sx={{ flex: 1 }}
                onClick={roleSubmit}
                variant="contained">
                {isLoading ? <CircularProgress size={18} sx={{ mr: 1, color: 'white' }} /> : null}
                Сохранить
              </Button>
            </Box>
          </FormControl>
        </Box>
      </Modal >
    </>
  );
};
